<template>
  <div v-loading="loading">
    <el-button size="small" @click="load">刷新{{ kind==='customer'?'客户360':'经营评估' }}</el-button>
    <el-alert v-if="error" :title="error" type="error" :closable="false" />
    <template v-if="data && !error">
      <template v-if="kind==='customer'">
        <p>当前可见未回款总额（含逾期）：<strong>{{ money(data.unpaidAmount) }} 元</strong></p>
        <p class="hint">各区块仅显示当前账号有权查看的记录；未回款总额包含全部可见期次，不受列表条数限制。</p>
        <section v-for="block in blocks" :key="block.key">
          <h4>{{ block.title }}</h4>
          <el-table :data="data[block.key].items" border>
            <el-table-column v-for="column in block.columns" :key="column[0]" :prop="column[0]" :label="column[1]" show-overflow-tooltip />
            <el-table-column v-if="block.key==='unpaidPayments'" label="当前状态" width="100"><template slot-scope="{row}">{{ paymentStatus(row) }}</template></el-table-column>
            <el-table-column label="操作" width="90"><template slot-scope="{row}"><el-button type="text" @click="openItem(block.key,row)">查看</el-button></template></el-table-column>
          </el-table>
          <p v-if="data[block.key].hasMore" class="hint">仅展示最近{{ data[block.key].limit }}条，更多记录请进入对应业务列表查看。</p>
        </section>
      </template>
      <template v-else>
        <p class="hint">{{ data.basis }}。系统不会自动改变商机阶段。</p>
        <el-descriptions :column="2" border>
          <el-descriptions-item label="统计日期">{{ data.asOfDate }}</el-descriptions-item>
          <el-descriptions-item label="阶段停留天数">{{ data.stageDays===null?'暂无日期':data.stageDays }}</el-descriptions-item>
          <el-descriptions-item label="距上次商机跟进">{{ data.daysSinceLastFollowup===null?'暂无记录':data.daysSinceLastFollowup+'天' }}</el-descriptions-item>
          <el-descriptions-item label="商机金额">{{ money(data.deal.amount) }} 元</el-descriptions-item>
          <el-descriptions-item label="人工填写赢率">{{ data.deal.winRate===null?'未填写':data.deal.winRate+'%' }}</el-descriptions-item>
        </el-descriptions>
        <p v-for="note in data.observations" :key="note">{{ note }}</p>
        <p v-if="!data.observations.length">当前未触发阶段停留或跟进间隔提示，请结合实际沟通结果判断。</p>
      </template>
    </template>
  </div>
</template>
<script>
import { crm } from '../api/crm'
import { paymentStatusLabel } from '../utils/crmPaymentStatus'
export default {
  props:{kind:String,recordId:[String,Number]},
  data:()=>({loading:false,error:'',data:null,requestId:0,blocks:[
    {key:'contacts',title:'联系人',columns:[['name','姓名'],['title','职务'],['phone','电话']]},
    {key:'openDeals',title:'进行中商机',columns:[['title','商机'],['stage','阶段'],['amount','金额（元）']]},
    {key:'recentActivities',title:'最近人工跟进',columns:[['createdAt','时间'],['channel','方式'],['content','内容']]},
    {key:'unpaidPayments',title:'未回款计划（含逾期）',columns:[['contractId','合同ID'],['periodName','期次'],['dueAt','到期日'],['amount','金额（元）']]}
  ]}),
  created(){this.load()},
  methods:{
    money(v){return Number(v || 0).toLocaleString('zh-CN',{minimumFractionDigits:2,maximumFractionDigits:2})},
    paymentStatus(row){return paymentStatusLabel(row,this.data.asOfDate)},
    openItem(block,row){
      if(!row || !row.id)return
      if(block==='openDeals')return this.$router.push('/crm/detail/deal/'+row.id)
      const path={contacts:'/crm/contact',recentActivities:'/crm/activity',unpaidPayments:'/crm/payment'}[block]
      if(path)this.$router.push({path,query:{recordId:row.id}})
    },
    async load(){
      const requestId=++this.requestId
      this.loading=true;this.error=''
      try{
        const res=await (this.kind==='customer'?crm.customer360(this.recordId):crm.dealAssessment(this.recordId))
        if(requestId===this.requestId)this.data=res.data
      }catch(e){
        if(requestId===this.requestId)this.error=e.message || '无法加载经营资料'
      }finally{
        if(requestId===this.requestId)this.loading=false
      }
    }
  }
}
</script>
<style scoped>.hint{color:#64748b;line-height:1.7}section{margin-top:22px}</style>
